import React from "react";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import AttachmentForm from "./components/AttachmentForm";

/**
 * AttachmentPage - Optimized wrapper component
 * 
 * Key improvements over AttachmentOld:
 * - Minimal location state dependencies
 * - URL parameter extraction
 * - Clean separation of concerns
 * - Better error handling
 * - Proper node management with getRevAllNodes
 */
const AttachmentPage = () => {
  const location = useLocation();
  const params = useParams();
  const [searchParams] = useSearchParams();
  
  // Extract URL parameters (primary data source)
  const {
    partnumber,
    revision,
    partId,
    revisionId,
    section_id_ref,
    step_id_ref,
    attachment_id_ref
  } = params;
  
  // Extract query parameters for special cases
  const substep_id_ref = searchParams.get("substep_id_ref");
  const node_id_ref = searchParams.get("node_id_ref");
  
  // Determine mode based on URL path
  const mode = location.pathname.includes("/edit-attachment") ? "edit" : "add";
  
  // Minimal location state usage (only for navigation-specific data)
  const { fromVersionHistory, versionHistoryData } = location.state || {};
  
  // Extract optional state data with fallbacks
  const {
    status,
    description,
    type,
    attachmentCount = 0,
    richCount = 0,
    canvasCount = 0,
    videoCount = 0,
    formCount = 0,
    stepNumber,
    data,
  } = location.state || {};

  return (
    <AttachmentForm
      // Core props
      mode={mode}
      

      // If mode is edit, then attachment_id_ref is the attachment ID
      attachment_id_ref={attachment_id_ref}
      
      // URL parameters
      partnumber={partnumber}
      revision={revision}
      partId={partId}
      revisionId={revisionId}
      section_id_ref={section_id_ref}
      step_id_ref={step_id_ref}
      substep_id_ref={substep_id_ref}
      node_id_ref={node_id_ref}

      
      // Version history props
      fromVersionHistory={fromVersionHistory}
      versionHistoryData={versionHistoryData}
      
      // Optional state data (with fallbacks)
      status={status}
      description={description}
      type={type}
      attachmentCount={attachmentCount}
      richCount={richCount}
      canvasCount={canvasCount}
      videoCount={videoCount}
      formCount={formCount}
      stepNumber={stepNumber}
      data={data}
    />
  );
};

export default AttachmentPage;

